import { Component, OnInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery-9';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  innerWidth: any;

  constructor() { }

  ngOnInit() {
    this.innerWidth = window.innerWidth;

    this.galleryOptions = [
      {
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
        previewCloseOnClick: true,
      },
      {
        fullWidth: true,
        thumbnailsColumns: 4,
        thumbnailsRows: 2,
        thumbnailMargin: 4,
        image: false,
      },
      {
        fullWidth: true,
        thumbnailsColumns: innerWidth>1200? 6: 4,
        thumbnailsRows: innerWidth>1200? 2: 3,
        thumbnailsMoveSize: 1,
        thumbnailMargin: 5,
        image: false,
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
        previewCloseOnClick: true,
      },
  ];

  this.galleryImages = [
      {
        small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207160/kwateryujac/1_cosccg.jpg',
        medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207160/kwateryujac/1_cosccg.jpg',
        big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207160/kwateryujac/1_cosccg.jpg'
    },
    {
      small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/2_pbdajo.jpg',
      medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/2_pbdajo.jpg',
      big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/2_pbdajo.jpg'
  },
  {
    small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207158/kwateryujac/3_y0upqm.jpg',
    medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207158/kwateryujac/3_y0upqm.jpg',
    big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207158/kwateryujac/3_y0upqm.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/4_s0v529.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/4_s0v529.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/4_s0v529.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/5_tqzubr.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/5_tqzubr.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/5_tqzubr.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/6_tc9goi.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/6_tc9goi.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207159/kwateryujac/6_tc9goi.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/7_jk56ca.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/7_jk56ca.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/7_jk56ca.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/8_fqvkh1.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/8_fqvkh1.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/8_fqvkh1.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/9_vjm6os.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/9_vjm6os.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/9_vjm6os.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/10_telnbu.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/10_telnbu.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207163/kwateryujac/10_telnbu.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/11_l5jvj9.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/11_l5jvj9.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207162/kwateryujac/11_l5jvj9.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/12_w9nnoz.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/12_w9nnoz.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207164/kwateryujac/12_w9nnoz.jpg'
},
{
  small: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207165/kwateryujac/13_jprhkp.jpg',
  medium: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207165/kwateryujac/13_jprhkp.jpg',
  big: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1612207165/kwateryujac/13_jprhkp.jpg'
},

  ];
}

}

